var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crypto-sign-info-page"},[(_vm.showCryptoSignInfo)?_c('modal',{attrs:{"size":"xl"},on:{"close":function($event){_vm.showCryptoSignInfo = false}}},[_c('crypto-sign-info')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }